export const PAYMENT_TYPE_CODE = {
    CASH_PAYMENT: 21910000001,
    CHEQUE_PAYMENT :21910000002,
    BANK_DEPOSIT :21910000003,
    CARD_PAYMENT:21910000004,
    OVER_PAYMENT:21910000005,
    RETURN_AMOUNT:21910000006,
    ONLINE_TRANSFER:21910000007,
}